import { Fragment } from "react";
import { Link } from "react-router-dom";

export interface PlaceTrailStop {
  label: string;
  to?: string;
}

/* The taxonomy position line: Framework → Domain → Function (→ Flow). Ruled,
 * plain links, the current page unlinked. Derivative stand-in for the design
 * system's PlaceTrail (backlog #15); swaps when upstream lands — recorded in
 * docs/design/marketing-register-migration-asks.md. */
export function PlaceTrail({ stops }: { stops: PlaceTrailStop[] }) {
  if (stops.length < 2) return null;
  return (
    <nav className="apf-place-trail" aria-label="Position in the framework">
      <ol>
        {stops.map((stop, index) => {
          const current = index === stops.length - 1;
          return (
            <Fragment key={`${stop.label}:${index}`}>
              <li aria-current={current ? "page" : undefined}>
                {stop.to && !current ? <Link to={stop.to}>{stop.label}</Link> : <span>{stop.label}</span>}
              </li>
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
}
